import { defineMessages } from 'react-intl';

export default defineMessages({
  DeviceElevatorIntegrationSettingsLabel: {
    defaultMessage: 'Elevator integration',
    description: 'Device Elevator integration settings - label',
    id: 'DeviceElevatorIntegrationSettings.label',
  },
});
